import PropTypes from "prop-types";

import { Link } from "react-router-dom";

import Icon from "./Icon";
import ExpandedInfo from "./ExpandInfo";
import T from "./translations/Translations";

/**
 * Display an application block containing its relevant information
 * @name ApplicationBlock
 * @param {{}} application
 * @param {bool} expand
 * @param {func} setExpand
 * @param {{}} student
 * @returns {JSX.Element}
 */
const ApplicationBlock = ({ application, expand, lang, setExpand, student }) => {
    const {
        body,
        buttons,
        endDate,
        startDate,
        status,
        statusColor,
        statusNumber,
        subBody,
        subBodyRange,
        subBody2,
        subBody2Range,
        subStatus,
        subStatusRange,
        title,
        icon
    } = application;

    if (!application) {
        return null;
    }

    return (
        <div className="application fade-style">
            <div className="application-header">
                <div className="left">
                    <div className="icon-title">
                        <div className="icon-container" style={{ background: "#808080" }}>
                            <Icon fill="white" height={65} iconName={icon} title={title} width={60} />
                        </div>
                    </div>
                    <div className="title-container">
                        {T({ key: title, langStr: lang })}
                        <div className="app-buttons-container">
                            {buttons &&
                                buttons.map((buttonObj, idx) => {
                                    const buttonKey = `app-${application.app}-button-${idx}`;
                                    const { clickIt, href, label, link } = buttonObj;
                                    return (
                                        <div key={buttonKey}>
                                            {href && (
                                                <a href={href}>
                                                    <button className="app-buttons">
                                                        {T({ key: label, langStr: lang })}
                                                    </button>
                                                </a>
                                            )}
                                            {link && (
                                                <Link to={link}>
                                                    <button className="app-buttons">
                                                        {T({ key: label, langStr: lang })}
                                                    </button>
                                                </Link>
                                            )}
                                            {clickIt && (
                                                <button
                                                    className="app-buttons"
                                                    onClick={() => {
                                                        setExpand(true);
                                                    }}
                                                >
                                                    {T({ key: label, langStr: lang })}
                                                </button>
                                            )}
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
                <div>
                    <div className="status-and-dates">
                        <div className="status">
                            <span className="label">
                                {status && <>{T({ key: "Global_Status", langStr: lang })}:</>}
                            </span>{" "}
                            <span className="info" style={{ color: statusColor }}>
                                {`${statusNumber || ""} ${T({ key: status, langStr: lang })}`}
                            </span>
                        </div>
                        {application.subStatus && (
                            <div className="sub-status">
                                {T({ key: subStatus, langStr: lang })} {subStatusRange || ""}
                            </div>
                        )}
                        {(startDate || endDate) && (
                            <div className="dates">
                                <span className="label">{T({ key: "Global_OpenFrom", langStr: lang })}: </span>
                                <span>
                                    {startDate && startDate}
                                    {startDate && endDate && " - "}
                                    {endDate && endDate}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <hr />
            <div className="application-body">
                {body && <div>{T({ key: body, langStr: lang })}</div>}
                {subBody && (
                    <div className="sub-body">
                        {T({ key: subBody, langStr: lang })} {subBodyRange || ""}
                        {subBody2 && (
                            <>
                                <br />
                                {T({ key: subBody2, langStr: lang })} {subBody2Range || ""}
                            </>
                        )}
                    </div>
                )}
                {expand && student && <ExpandedInfo setExpand={setExpand} student={student} />}
            </div>
        </div>
    );
};

ApplicationBlock.propTypes = {
    application: PropTypes.oneOfType([PropTypes.object]).isRequired,
    expand: PropTypes.bool,
    lang: PropTypes.string,
    setExpand: PropTypes.func,
    student: PropTypes.oneOfType([PropTypes.object])
};

ApplicationBlock.defaultProps = {
    expand: false,
    lang: "en",
    setExpand: null,
    student: null
};

export default ApplicationBlock;
